import styled, { css, keyframes } from 'styled-components';

export const Container = styled.div<{ isplaying: string }>`
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background-color: ${({ isplaying }) => (isplaying === 'true' ? 'white' : '#E4E4E4')};

`;

export const Header = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 22px 0;
`;

export const HeaderContents = styled.div`
    font-size: 20px;
    font-weight: 500;
    padding: 0 28px;
    display: flex;
    align-items: center;
    &.main {
        font-size: 18px;
    }
    img {
        width: 35px;
        margin-right: 16px;
    }
    &.navigate {
        cursor: pointer;
    }
`;

export const Title = styled.div`
    font-size: 56px;
    font-weight: 700;
    line-height: normal;
`;

export const SubTitle = styled.div`
   font-size: 20px;
`;

export const Keywords = styled.div`
    height: 30px;
    display: flex;
    gap: 6px;

    span {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #424242;
        padding: 8px;
        color: #424242;
        font-size: 14px;
    }
`;

export const Transcript = styled.div`
    font-size: 41px;
    line-height: 60px;
    margin: 64px 32px 92px 38px;
    height: 282px;
    display: flex;
    flex-direction: column;
    gap: 62px;
    line-height: 70.5px;
    letter-spacing: -1.23px;
    &.subscribe {
        line-height: 58px;
    }
    p {
        margin: 0;
    }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const SubscribeContainer = styled.div`
    animation: ${fadeIn} 0.6s ease-in-out;
`;

const fadeInBackground = (color: string) => keyframes`
    from { background-color: transparent; }
    to { background-color: ${color}; }
`;

export const HighlightedText = styled.span<{ highlight: string; color: string }>`
    background-color: ${({ highlight, color }) => (highlight === 'true' ? color : 'transparent')};
    margin-right: 10px;
    ${({ highlight, color }) =>
        highlight === 'true' &&
        css`
            animation: ${fadeInBackground(color)} 0.5s ease-in-out;
        `}
`;

export const AudioPlayer = styled.audio`
    display: none;
`;

export const ImageContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 834px;
    position: relative;
`;

const pulse = keyframes`
  0% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
`;

export const ProjectImage = styled.img<{ isplaying: string }>`
  width: 610px;
  height: 610px;

  ${({ isplaying }) =>
        (isplaying === 'true') &&
        css`
      animation: ${pulse} 5s infinite;
    `}
  transition: transform 0.3s ease;
`;

export const ProgressBarWrapper = styled.div`
    width: 100%;
    height: 1.5px;
    background-color: #B5B5B5;
    position: relative;
`;

export const Progress = styled.div`
    height: 100%;
    background-color: black;
    transition: width 0.5s ease;
`;

export const InfoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 60px 38px 0 38px;
`

export const Contents = styled.div`
    display: flex;
    flex-direction: column;
    gap: 22px;
`;

export const Subscribe = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 11px;
    width: 104px;
    font-size: 18px;
    font-weight: 500;
`;

export const Navigator = styled.div`
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 47px;
    cursor: pointer;

    img {
        width: 22px;
        margin-right: 14px;
    }
`;